"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var graphic_1 = require("../models/graphic");
var GraphicComponent = /** @class */ (function (_super) {
    __extends(GraphicComponent, _super);
    function GraphicComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onLineDragStart = function (ev) {
            ev.stopPropagation();
            // left-click only
            if (ev.nativeEvent.which !== 1) {
                ev.preventDefault();
                return;
            }
            var _a = _this.props, id = _a.id, lineMouseDown = _a.lineMouseDown;
            if (lineMouseDown) {
                return lineMouseDown(id);
            }
        };
        _this.onLineDragEnd = function (ev) {
            ev.stopPropagation();
            var _a = _this.props, id = _a.id, lineMouseRelease = _a.lineMouseRelease;
            if (lineMouseRelease) {
                return lineMouseRelease(id);
            }
        };
        _this.onDotStretchStart = function (ev, fixedPoint) {
            ev.stopPropagation();
            // left-click only
            if (ev.nativeEvent.which !== 1) {
                ev.preventDefault();
                return;
            }
            var _a = _this.props, id = _a.id, dotMouseDown = _a.dotMouseDown;
            if (dotMouseDown) {
                // replace and attach mouseup listener for entire window
                _this.removeMouseUpListener();
                _this.mouseUpListener = _this.onDotStretchEnd(fixedPoint);
                window.addEventListener("mouseup", _this.mouseUpListener);
                return dotMouseDown(id, fixedPoint);
            }
        };
        _this.onDotStretchEnd = function (fixedPoint) { return function (ev) {
            ev.stopPropagation();
            // remove mouseup listener if it's there
            _this.removeMouseUpListener();
            var _a = _this.props, id = _a.id, dotMouseRelease = _a.dotMouseRelease;
            if (dotMouseRelease) {
                return dotMouseRelease(id, fixedPoint);
            }
        }; };
        _this.removeMouseUpListener = function () {
            if (_this.mouseUpListener) {
                window.removeEventListener("mouseup", _this.mouseUpListener);
            }
        };
        _this.onLabelDragStart = function (ev) {
            ev.stopPropagation();
            // left-click only
            if (ev.nativeEvent.which !== 1) {
                ev.preventDefault();
                return;
            }
            var _a = _this.props, id = _a.id, labelDragStart = _a.labelDragStart;
            if (labelDragStart) {
                return labelDragStart(id);
            }
        };
        _this.onLabelDragEnd = function (ev) {
            ev.stopPropagation();
            var _a = _this.props, id = _a.id, labelDragEnd = _a.labelDragEnd;
            if (labelDragEnd) {
                return labelDragEnd(id);
            }
        };
        _this.percentStr = function (value) {
            if (isFinite(value)) {
                return value + "%";
            }
            return "0%";
        };
        return _this;
    }
    GraphicComponent.prototype.render = function () {
        var _this = this;
        var _a = this.props, start = _a.start, end = _a.end, labelText = _a.labelText, labelPoint = _a.labelPoint, color = _a.color, showDragElements = _a.showDragElements, isFocused = _a.isFocused, fontSize = _a.fontSize;
        var dotRadius = "3px";
        var strokeWidth = "1px";
        var x1 = this.percentStr(start.xPercent);
        var y1 = this.percentStr(start.yPercent);
        var x2 = this.percentStr(end.xPercent);
        var y2 = this.percentStr(end.yPercent);
        var focusedClassName = isFocused ? "ma-focused" : "";
        var startDot = react_1.default.createElement("ellipse", { cx: x1, cy: y1, rx: dotRadius, ry: dotRadius, fill: color });
        var endDot = react_1.default.createElement("ellipse", { cx: x2, cy: y2, rx: dotRadius, ry: dotRadius, fill: color });
        var line = react_1.default.createElement("line", { x1: x1, y1: y1, x2: x2, y2: y2, strokeWidth: strokeWidth, stroke: color });
        var labelEl;
        if (labelText && labelPoint) {
            var labelXPercent = labelPoint.xPercent;
            var labelYPercent = labelPoint.yPercent;
            var labelX = (isFinite(labelXPercent) || 0) && this.percentStr(labelXPercent);
            var labelY = (isFinite(labelYPercent) || 0) && this.percentStr(labelYPercent);
            var fontSizeStyle = { fontSize: fontSize ? fontSize : graphic_1.DEFAULT_FONT_SIZE };
            labelEl = react_1.default.createElement("text", { x: labelX, y: labelY, textAnchor: "middle", stroke: "none", onMouseDown: this.onLabelDragStart, onMouseUp: this.onLabelDragEnd, style: fontSizeStyle }, labelText);
        }
        var draggableLine;
        var adjustableStartDot;
        var adjustableEndDot;
        var adjustableGroup;
        if (showDragElements) {
            adjustableStartDot = react_1.default.createElement("ellipse", { className: "ma-draggable", cx: x1, cy: y1, rx: "10px", ry: "10px", fill: color, onMouseDown: function (ev) { return _this.onDotStretchStart(ev, end); } });
            adjustableEndDot = react_1.default.createElement("ellipse", { className: "ma-draggable", cx: x2, cy: y2, rx: "10px", ry: "10px", fill: color, onMouseDown: function (ev) { return _this.onDotStretchStart(ev, start); } });
            var dragLineProportion = 0.15;
            var dragStartX = (end.xPercent - start.xPercent) * dragLineProportion + start.xPercent;
            var dragStartY = (end.yPercent - start.yPercent) * dragLineProportion + start.yPercent;
            var dragEndX = (end.xPercent - start.xPercent) * (1 - dragLineProportion) + start.xPercent;
            var dragEndY = (end.yPercent - start.yPercent) * (1 - dragLineProportion) + start.yPercent;
            draggableLine = react_1.default.createElement("line", { className: "ma-draggable " + focusedClassName, x1: this.percentStr(dragStartX), y1: this.percentStr(dragStartY), x2: this.percentStr(dragEndX), y2: this.percentStr(dragEndY), onMouseDown: this.onLineDragStart, onMouseUp: this.onLineDragEnd, strokeWidth: "20px" });
            adjustableGroup = react_1.default.createElement("g", null,
                adjustableStartDot,
                adjustableEndDot,
                draggableLine);
        }
        return react_1.default.createElement("g", { fill: color, stroke: color },
            line,
            startDot,
            endDot,
            adjustableGroup,
            labelEl);
    };
    return GraphicComponent;
}(react_1.default.PureComponent));
exports.GraphicComponent = GraphicComponent;
